import React from 'react';
import Breadcrumbs from '../components/Breadcrumb';
import CommonBanner from '../components/CommonBanner';
import PVElectrolyserTech from '../components/technology/PVElectrolyserTech';

const Technology = () => {
  const breadcrumbItems = ['Technology', 'PV Electrolyser'];

  return (
    <div>
      <div className='mt-16 sm:mt-20 md:mt-24 lg:mt-24 mx-6 sm:mx-8 md:mx-10 lg:mx-20'>
        <Breadcrumbs item1={breadcrumbItems[0]} item2={breadcrumbItems[1]} />
      </div>
      <div className="border-b border-gray-200 mt-2"></div>

      <div>
        <CommonBanner 
          topTitle="Our Tech"
          bannerImage="https://images.unsplash.com/photo-1622801026801-f7c7b305026f?q=80&w=2877&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          bannerImageAlt="Green Molecules Electrolysers"
          bannerTitle="PV Electrolyser Modules"
          welcomeTitle="Integrated PV-Electrolyser Modules: Advancing Affordable Clean Energy"
          welcomeDescription="Our Integrated PV-Electrolyser Modules combine solar energy generation and hydrogen production into a single, cost-effective system. Designed to be scalable, efficient, and simple, this innovative technology is paving the way for affordable clean energy solutions."
        />
        <PVElectrolyserTech />
      </div>
    </div>
  )
}

export default Technology;
